<template>
    <div id="bst-wrap">
      <div class="l-project-wrap l-project-wrap--mypage is-hide">

        <Header />

        <section class="l-content-area">
          <div class="l-content">

            <!-- MYPAGE -->
            <section class="p-bloc p-bloc--mypage">
              <div class="p-bloc__content l-wrap__outer">
                <div class="l-wrap__inner">

                  <section class="p-mypage">

                    <!-- Mypage Menu -->
                    <NavbarMyPage/>
                    <!-- Side Menu -->
                    <SideMenu/>

                    <!-- Mypage Content -->
                    <div class="p-mypage__content">
                      <div class="mypage-content">

                        <!-- page -->
                        <div class="p-mypage__page mypage-bloc">
                          <div class="mypage-bloc__content">

                            <!-- page - kiyaku -->
                            <div class="page__bloc page__bloc--terms c-kiyaku">
                              <h1>{{ $t('LABEL_MERCHANT_TERM_OF_USE') }}</h1>

                              <p>{{ $t('TEXT_TERMS_OF_USE_1') }}</p>
                              <p>{{ $t('TEXT_TERMS_OF_USE_2') }}</p>

                              <h2>{{ $t('TEXT_TERMS_OF_USE_3') }}</h2>
                              <p>{{ $t('TEXT_TERMS_OF_USE_4') }}</p>
                              <ol>
                                <li>{{ $t('TEXT_TERMS_OF_USE_5') }}</li>
                                <li>{{ $t('TEXT_TERMS_OF_USE_6') }}</li>
                                <li>{{ $t('TEXT_TERMS_OF_USE_7') }}</li>
                                <li>{{ $t('TEXT_TERMS_OF_USE_8') }}</li>
                              </ol>

                              <h2>{{ $t('TEXT_TERMS_OF_USE_9') }}</h2>
                              <ol>
                                <li>{{ $t('TEXT_TERMS_OF_USE_10') }}</li>
                                <li>{{ $t('TEXT_TERMS_OF_USE_11') }}</li>
                                <li>{{ $t('TEXT_TERMS_OF_USE_12') }}</li>
                              </ol>

                              <h2>{{ $t('TEXT_TERMS_OF_USE_13') }}</h2>
                              <ol>
                                <li>{{ $t('TEXT_TERMS_OF_USE_14') }}</li>
                                <li>{{ $t('TEXT_TERMS_OF_USE_15') }}</li>
                                <li>{{ $t('TEXT_TERMS_OF_USE_16') }}</li>
                                <li>{{ $t('TEXT_TERMS_OF_USE_17') }}</li>
                                <li>{{ $t('TEXT_TERMS_OF_USE_18') }}</li>
                                <li>{{ $t('TEXT_TERMS_OF_USE_19') }}</li>
                              </ol>

                              <h2>{{ $t('TEXT_TERMS_OF_USE_20') }}</h2>
                              <ol>
                                <li>{{ $t('TEXT_TERMS_OF_USE_21') }}</li>
                                <li>{{ $t('TEXT_TERMS_OF_USE_22') }}<br>
                                    {{ $t('TEXT_TERMS_OF_USE_23') }}</li>
                                <li>{{ $t('TEXT_TERMS_OF_USE_24') }}</li>
                                <li>{{ $t('TEXT_TERMS_OF_USE_25') }}<br>
                                    {{ $t('TEXT_TERMS_OF_USE_26') }}</li>
                              </ol>

                              <h2>{{ $t('TEXT_TERMS_OF_USE_27') }}</h2>
                              <ol>
                                <li>{{ $t('TEXT_TERMS_OF_USE_28') }}</li>
                                <li>{{ $t('TEXT_TERMS_OF_USE_29') }}</li>
                              </ol>

                              <h2>{{ $t('TEXT_TERMS_OF_USE_30') }}</h2>
                              <ol>
                                <li>{{ $t('TEXT_TERMS_OF_USE_31') }}</li>
                                <li>{{ $t('TEXT_TERMS_OF_USE_32') }}</li>
                                <li>{{ $t('TEXT_TERMS_OF_USE_33') }}</li>
                              </ol>

                              <h2>{{ $t('TEXT_TERMS_OF_USE_34') }}</h2>
                              <ol>
                                <li>{{ $t('TEXT_TERMS_OF_USE_35') }}</li>
                                <li>{{ $t('TEXT_TERMS_OF_USE_36') }}</li>
                                <li>{{ $t('TEXT_TERMS_OF_USE_37') }}</li>
                              </ol>

                              <h2>{{ $t('TEXT_TERMS_OF_USE_38') }}</h2>
                              <ol>
                                <li>{{ $t('TEXT_TERMS_OF_USE_39') }}</li>
                                <li>{{ $t('TEXT_TERMS_OF_USE_40') }}</li>
                                <li>{{ $t('TEXT_TERMS_OF_USE_41') }}</li>
                                <li>{{ $t('TEXT_TERMS_OF_USE_42') }}</li>
                                <li>{{ $t('TEXT_TERMS_OF_USE_43') }}</li>
                                <li>{{ $t('TEXT_TERMS_OF_USE_44') }}</li>
                              </ol>

                              <h2>{{ $t('TEXT_TERMS_OF_USE_45') }}</h2>
                              <ol>
                                <li>{{ $t('TEXT_TERMS_OF_USE_46') }}</li>
                                <li>{{ $t('TEXT_TERMS_OF_USE_47') }}</li>
                              </ol>

                              <h2>{{ $t('TEXT_TERMS_OF_USE_48') }}</h2>
                              <p>{{ $t('TEXT_TERMS_OF_USE_49') }}</p>

                              <h2>{{ $t('TEXT_TERMS_OF_USE_50') }}</h2>
                              <ol>
                                <li>{{ $t('TEXT_TERMS_OF_USE_51') }}</li>
                                <li>{{ $t('TEXT_TERMS_OF_USE_52') }}</li>
                              </ol>

                              <h2>{{ $t('TEXT_TERMS_OF_USE_53') }}</h2>
                              <ol>
                                <li>{{ $t('TEXT_TERMS_OF_USE_54') }}</li>
                                <li>{{ $t('TEXT_TERMS_OF_USE_55') }}</li>
                                <li>{{ $t('TEXT_TERMS_OF_USE_56') }}</li>
                                <li>{{ $t('TEXT_TERMS_OF_USE_57') }}</li>
                              </ol>

                              <h2>{{ $t('TEXT_TERMS_OF_USE_58') }}</h2>
                              <ol>
                                <li>{{ $t('TEXT_TERMS_OF_USE_59') }}<br>
                                  <ol class="paren">
                                    <li>{{ $t('TEXT_TERMS_OF_USE_60') }}</li>
                                    <li>{{ $t('TEXT_TERMS_OF_USE_61') }}</li>
                                    <li>{{ $t('TEXT_TERMS_OF_USE_62') }}</li>
                                    <li>{{ $t('TEXT_TERMS_OF_USE_63') }}</li>
                                    <li>{{ $t('TEXT_TERMS_OF_USE_64') }}</li>
                                    <li>{{ $t('TEXT_TERMS_OF_USE_65') }}</li>
                                    <li>{{ $t('TEXT_TERMS_OF_USE_66') }}</li>
                                    <li>{{ $t('TEXT_TERMS_OF_USE_67') }}</li>
                                    <li>{{ $t('TEXT_TERMS_OF_USE_68') }}</li>
                                    <li>{{ $t('TEXT_TERMS_OF_USE_69') }}</li>
                                    <li>{{ $t('TEXT_TERMS_OF_USE_70') }}</li>
                                  </ol></li>
                                <li>{{ $t('TEXT_TERMS_OF_USE_71') }}</li>
                                <li>{{ $t('TEXT_TERMS_OF_USE_72') }}</li>
                              </ol>

                              <h2>{{ $t('TEXT_TERMS_OF_USE_73') }}</h2>
                              <ol>
                                <li>{{ $t('TEXT_TERMS_OF_USE_74') }}<a href="/privacypolicy">{{ $t('LABEL_PRIVACY_POLICY') }}</a>{{ $t('TEXT_TERMS_OF_USE_75') }}<a href="/personal-information">{{ $t('LABEL_HANDLING_OF_PERSONAL_DATA') }}</a>{{ $t('TEXT_TERMS_OF_USE_76') }}</li>
                                <li>{{ $t('TEXT_TERMS_OF_USE_77') }}</li>
                              </ol>

                              <h2>{{ $t('TEXT_TERMS_OF_USE_78') }}</h2>
                              <ol>
                                <li>{{ $t('TEXT_TERMS_OF_USE_79') }}</li>
                                <li>{{ $t('TEXT_TERMS_OF_USE_80') }}</li>
                                <li>{{ $t('TEXT_TERMS_OF_USE_81') }}</li>
                              </ol>

                              <h2>{{ $t('TEXT_TERMS_OF_USE_82') }}</h2>
                              <ol>
                                <li>{{ $t('TEXT_TERMS_OF_USE_83') }}<br>
                                    {{ $t('TEXT_TERMS_OF_USE_84') }}</li>
                                <li v-html="$t('TEXT_TERMS_OF_USE_85')"></li>
                                <li v-html="$t('TEXT_TERMS_OF_USE_86')"></li>
                                <li>{{ $t('TEXT_TERMS_OF_USE_87') }}<br>
                                    {{ $t('TEXT_TERMS_OF_USE_88') }}<br>
                                    {{ $t('TEXT_TERMS_OF_USE_89') }}<br>
                                  <a href="http://www.google.com/analytics" target="_blank">http://www.google.com/analytics</a></li>
                              </ol>

                              <h2>{{ $t('TEXT_TERMS_OF_USE_90') }}</h2>
                              <p>{{ $t('TEXT_TERMS_OF_USE_91') }}</p>

                              <h2>{{ $t('TEXT_TERMS_OF_USE_92') }}</h2>
                              <p>{{ $t('TEXT_TERMS_OF_USE_93') }}</p>

                              <p class="right-side">{{ $t('TEXT_TERMS_OF_USE_94') }}</p>
                              <p class="right-side" v-html="$t('TEXT_TERMS_OF_USE_95')"></p>

                            </div>


                          </div>
                        </div>

                      </div><!-- .mypage-content -->
                    </div>

                  </section>

                </div>
              </div>
            </section>


          </div><!-- .l-content -->
        </section><!-- .l-content-area -->

      </div><!-- .l-project-wrap -->

      <Footer/>
    </div>
</template>
<script setup>
import NavbarMyPage from "@/components/NavbarMyPage.vue";
import Footer from "@/components/Footer.vue";
import SideMenu from "@/components/SideMenu.vue";
import Header from "@/components/Header.vue";
</script>